export default class Submenu {
  constructor() {
    this.submenuWrappers = document.querySelectorAll('.submenu-wrapper')
    this.activeSubmenu = null
    this.hoverTimeout = null
    this.init()
  }

  init() {
    this.submenuWrappers.forEach((wrapper) => {
      const toggle = wrapper.querySelector('.submenu-toggle')
      const submenu = wrapper.querySelector('.submenu')

      if (!toggle || !submenu) return

      wrapper.addEventListener('mouseenter', () => this.openSubmenu(wrapper, toggle, submenu))
      wrapper.addEventListener('mouseleave', () => this.closeSubmenu(wrapper, toggle, submenu))

      toggle.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleSubmenu(wrapper, toggle, submenu)
      })

      toggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          this.toggleSubmenu(wrapper, toggle, submenu)
        } else if (e.key === 'Escape') {
          this.closeSubmenu(wrapper, toggle, submenu)
        } else if (e.key === 'ArrowDown') {
          e.preventDefault()
          this.openSubmenu(wrapper, toggle, submenu)
          const firstLink = submenu.querySelector('a')
          if (firstLink) firstLink.focus()
        }
      })

      const menuItems = submenu.querySelectorAll('a')
      menuItems.forEach((item, index) => {
        item.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault()
            const nextItem = menuItems[index + 1]
            if (nextItem) nextItem.focus()
          } else if (e.key === 'ArrowUp') {
            e.preventDefault()
            if (index === 0) {
              toggle.focus()
            } else {
              menuItems[index - 1].focus()
            }
          } else if (e.key === 'Escape') {
            e.preventDefault()
            this.closeSubmenu(wrapper, toggle, submenu)
            toggle.focus()
          }
        })
      })
    })

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.submenu-wrapper')) {
        this.closeAllSubmenus()
      }
    })
  }

  openSubmenu(wrapper, toggle, submenu) {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout)
    }

    this.closeAllSubmenus()

    submenu.classList.remove('hidden')
    submenu.classList.add('flex')
    toggle.classList.add('open')
    toggle.setAttribute('aria-expanded', 'true')
    this.activeSubmenu = { wrapper, toggle, submenu }
  }

  closeSubmenu(wrapper, toggle, submenu) {
    this.hoverTimeout = setTimeout(() => {
      submenu.classList.add('hidden')
      submenu.classList.remove('flex')
      toggle.classList.remove('open')
      toggle.setAttribute('aria-expanded', 'false')
      if (this.activeSubmenu && this.activeSubmenu.wrapper === wrapper) {
        this.activeSubmenu = null
      }
    }, 200)
  }

  toggleSubmenu(wrapper, toggle, submenu) {
    const isOpen = !submenu.classList.contains('hidden')

    if (isOpen) {
      this.closeSubmenu(wrapper, toggle, submenu)
    } else {
      this.openSubmenu(wrapper, toggle, submenu)
    }
  }

  closeAllSubmenus() {
    this.submenuWrappers.forEach((wrapper) => {
      const toggle = wrapper.querySelector('.submenu-toggle')
      const submenu = wrapper.querySelector('.submenu')
      if (toggle && submenu) {
        submenu.classList.add('hidden')
        toggle.setAttribute('aria-expanded', 'false')
      }
    })
    this.activeSubmenu = null
  }
}
